interface PageHeaderProps {
  monthLabel: string;
  entryCount: number;
  submitterCount: number;
}

function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

/**
 * Page-level header sitting below the TopBar. AOZONE-37: shows the month
 * being viewed (PageHeader H1 — only H1 on the page) plus a subtitle with
 * total entry + submitter counts for the current month.
 */
export function PageHeader({
  monthLabel,
  entryCount,
  submitterCount,
}: PageHeaderProps) {
  return (
    <header className="mb-8">
      <h1 className="text-3xl font-semibold tracking-tight text-slate-900">
        MBR — {monthLabel}
      </h1>
      <p className="mt-2 text-sm text-slate-500">
        {plural(entryCount, 'entry', 'entries')}
        {' · '}
        {plural(submitterCount, 'submitter', 'submitters')}
      </p>
    </header>
  );
}
